<template>
  <div>
    <vue-recaptcha @verify="setResponse" @expired="clearResponse" @error="clearResponse" :sitekey="recaptchaSiteKey"
                   :loadRecaptchaScript="true"></vue-recaptcha>
    <v-messages v-if="hasError"
                :value="[trans('app.confirm_captcha')]"
                :color="`error`"></v-messages>
  </div>
</template>
<script>

import VueRecaptcha from "vue-recaptcha";

export default {
  props: {
    recaptchaSiteKey: String,
  },
  data() {
    return {
      response: '',
      hasError: false
    }
  },
  components: {VueRecaptcha},
  methods: {
    setResponse(response) {
      this.clearResponse();
      this.response = response;
    },
    clearResponse() {
      this.hasError = false;
      this.response = '';
    },
    verify() {
      const isVerified = this.response !== '';
      this.hasError = !isVerified;
      return isVerified;
    },
    getResponse() {
      return this.response;
    }
  }
}
</script>